(function () {
  // Cherry Hill V10 self-contained hero slider.
  // Stacked slides + opacity cross-fade (CSS). Dots set the active slide directly.
  // Does NOT drive Booster's native carousel buttons. Manual only, no autoplay.
  function initV10Hero() {
    var slider = document.querySelector('.s__holder.slider--responsive');
    if (!slider) return;
    var holder = slider.querySelector('[data-bstr-slide-holder]');
    if (!holder) return;
    var slides = Array.prototype.slice.call(holder.querySelectorAll('[data-bstr-slide]'));
    if (slides.length < 2) return;
    if (slider.querySelector('.ch-v10-dots')) return;

    // Take over layout: CSS keyed on this class stacks slides and cross-fades them.
    slider.classList.add('ch-v10-hero');

    var dots = [];
    function setActive(idx) {
      for (var i = 0; i < slides.length; i++) {
        var on = (i === idx);
        slides[i].classList.toggle('ch-v10-active', on);
        slides[i].inert = !on;
        slides[i].setAttribute('aria-hidden', on ? 'false' : 'true');
        if (dots[i]) dots[i].classList.toggle('active', on);
      }
    }

    var dotsEl = document.createElement('div');
    dotsEl.className = 'ch-v10-dots';
    slides.forEach(function (s, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ch-v10-dot';
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      dot.setAttribute('data-index', i);
      dot.addEventListener('click', function () { setActive(i); });
      dots.push(dot);
      dotsEl.appendChild(dot);
    });
    slider.appendChild(dotsEl);

    setActive(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initV10Hero);
  } else {
    initV10Hero();
  }
  window.addEventListener('load', function () { setTimeout(initV10Hero, 300); });
})();
